import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t-2 border-gold bg-grape-deep text-white" data-id="element-56" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-57" data-mp="3gh3rqfvjs8fo">
        <p className="font-display text-xl font-black text-white" data-id="element-58" data-mp="36pft9v0kpr4p">
          SIGMA SMART<span className="align-super text-xs" data-id="element-59" data-mp="36nd5lhmw8a35">™</span> — THE AI BOOK BUILDER<span className="align-super text-xs" data-id="element-60" data-mp="3ugbshd7czolz">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-gold-soft" data-id="element-61" data-mp="38h81hlebwon">
          Build the book. Not just the idea.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/80" data-id="element-62" data-mp="3ldu2qoshwdu8">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-63" data-mp="3qfjighqnxfon">
            <MailIcon className="h-4 w-4 text-gold-soft" data-id="element-64" data-mp="2eyjoziskwut1" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="3lalgthavm9v0">
            <InstagramIcon className="h-4 w-4 text-gold-soft" data-id="element-66" data-mp="3gc0glhvmjq6k" /> @sigmasmart.en
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/60" data-id="element-67" data-mp="3v9193nln3p63">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="3q7bxo6ui99hh">
            Terms &amp; Conditions
          </a>
          <span data-id="element-69" data-mp="3472hh8p3xw3">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-70" data-mp="32w1tqajr697">
            Privacy Policy
          </a>
          <span data-id="element-71" data-mp="hs1x5369kcbt">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-72" data-mp="ctqogvrpg7v6">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/50" data-id="element-73" data-mp="qujlbn5hbf1g">
          © 2026 SIGMA SMART™ — All rights reserved.
        </p>
      </div>
    </footer>;
}